import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: Error): void {
    // Log errors in non-production environments
    if (!environment.production) {
      console.error('Global error caught:', error);
    }

    // In a real application, you might want to:
    // - Send errors to a logging service
    // - Display a user-friendly error message
    // - Report to analytics/monitoring service
  }
}
